
// axios
import request from '@/utils/request'
// 根据环境不同引入不同api地址
import { baseWss } from '@/config'
import qs from 'qs'
// import './home'

//cache通过localStorage存储数据，value设置null则为删除
export function cache(key,value) {

  if(value!==undefined){
    if(value!=null){
      localStorage.setItem(key,JSON.stringify({data:value}))
    }else {
      localStorage.removeItem(key)
    }
  } else{
    var temp=localStorage.getItem(key)
    if(temp==null){
      return null
    }
   return  JSON.parse(temp).data
  }

  return value
}

// 搜索数据列表数据或者数数据
export function search(url,params) {
  var token=cache("token")
  if(token!=null){
    if(params==null){
      params={}
    }
    params["token"]=token
  }
  return request({
    url: url,
    method: 'GET',
    hideloading: true,
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

// 查询单条数据
export function info(url,param) {
  var token=cache("token")
  if(token!=null){
    if(param==null){
      param={}
    }
    param["token"]=token
  }
  return request({
    url: url,
    method: 'GET',
    hideloading: true,
    params: param
  })
}

// 删除任务
export function del(url,params) {
  var token=cache("token")
  if(token!=null){
    if(params==null){
      params={}
    }
    params["token"]=token
  }
  return request({
    url: url,
    method: 'DELETE',
    hideloading: true,
    data: qs.stringify(params)
  })
}

// 修改任务
export function edit(url,params) {
  var token=cache("token")
  if(token!=null){
    if(params==null){
      params={}
    }
    params["token"]=token
  }
  return request({
    url: url,
    method: 'PUT',
    hideloading: true,
    data: qs.stringify(params)
  })
}

// 新增任务
export function add(url,params) {
  var token=cache("token")
  if(token!=null){
    if(params==null){
      params={}
    }
    params["token"]=token
  }
  return request({
    url: url,
    method: 'POST',
    hideloading: true,
    data: qs.stringify(params)
  })
}
// 上传任务
export function upload(file) {
  const param = new FormData()
  // 将得到的文件流添加到FormData对象
  param.append('file', file, file.name)
  var token=cache("token")
  if(token!=null){
    param.append('token', token)
  }
  return request({
    url: '../file',
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'POST',
    hideloading: true,
    data: param
  })
}

export var ws={
  wsUrl: baseWss+"websocket/conn",
  setClose: false,
  client: null,
  callbackMap: {},
  init: function (option) {
    
    var that = this
    that.setClose = false
    var token=cache("token")
    var url=that.wsUrl
    if(token!=null){
      url=url+"?token="+token
    }

    this.client = new WebSocket(url);   //建立连接
    this.client.onopen = function () {  //发送请求
      if(option.init!=null){
        option.init()
      }
      // that.send("upan/get", {}, function (res) {
      //   console.log(res)
      // })
    };
    this.client.onmessage = function (res) {
      that.onmessage(res, option)
    }
    this.client.onclose = function () {
      that.init()
    };
  },

  onmessage: function (res, option) {
    var that = this
    var data = JSON.parse(res.data)
    if (data["id"] != null && that.callbackMap[data["id"]] != null) {
      that.callbackMap[data["id"]](data["data"])
      delete that.callbackMap[data["id"]]
      return
    }
    switch (data["type"]) {
      case "upan/insert":
        option.upanInsert(data);
        break;
      case "upan/remove":
        option.upanRemove(data);
        break;
      case "system/push":
        that.onIEmessage(data.data,data.clientID);
        break;
      default:
        console.log(data);
        break;
    }
  },
  send: function (type, data, callback) {
    if (this.client == null) {
      return
    }
    var id = "req" + new Date().getTime() + parseInt(Math.random() * 1000)
    if (callback != null) {
      this.callbackMap[id] = callback
    }

    this.client.send(JSON.stringify({type: type, data: data, id: id}))
  }

}



